import { Typography } from "@mui/material";
import { ReactComponent as CheckIcon } from "components/Icons/checkFilled.svg";
import { CellAlign, OLTable, createHeadItems } from "components/Table/OLTable";
import { Tooltip } from "components/Tooltips/Tooltip";
import { handledCampaignTriggers } from "constants/general";
import { useMessage } from "hooks/intl";
import { useCallback } from "react";
import { Link } from "react-router-dom";
import { CAMPAING_IMPORT_SUCCESS_ID } from "state/tables/types";
import { CampaignBEData } from "types/campaigns";
import { links } from "utilities/links";
import { useStyles } from "./CampaignImportList";

export const SuccessfulImports = ({
  campaigns,
  disableTitle,
}: {
  campaigns: CampaignBEData[];
  disableTitle?: boolean;
}) => {
  const { message } = useMessage();
  const classes = useStyles();

  const headItems = createHeadItems([
    {
      headerText: message({ id: "campaignName" }),
      property: "name",
      isSortable: false,
    },
    {
      headerText: message({ id: "campaignType" }),
      property: "type",
      isSortable: false,
    },
    {
      headerText: message({ id: "campaignTrigger" }),
      property: "trigger",
      isSortable: false,
    },
    {
      headerText: "",
      property: "view",
      isSortable: false,
      customWidth: "100px",
    },
  ]);

  const createItems = useCallback(
    (items: CampaignBEData[]) => {
      return items.map((item) => {
        return {
          cells: [
            {
              content: (
                <span className={classes.nameTdWrapper}>
                  <CheckIcon className={classes.icon} />
                  <Tooltip text={item.name} placement="bottom-end">
                    <span className={classes.name}> {item.name || "-"}</span>
                  </Tooltip>
                </span>
              ),
              nonClickable: true,
              property: "name",
            },
            { content: message({ id: item.type }), property: "type" },
            {
              content: message({
                id: handledCampaignTriggers.find(
                  (trigger) => trigger.id === item.trigger,
                )?.label,
              }),
              property: "trigger",
            },
            {
              content: (
                <div className={classes.linkWrapper}>
                  <Link
                    className={classes.link}
                    to={links.campaign(item.campaignId)}
                    target="_blank"
                  >
                    {message({ id: "view" })}
                  </Link>
                </div>
              ),
              property: "view",
              align: CellAlign.CENTER,
            },
          ],
          id: item.campaignId,
        };
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [campaigns],
  );

  return (
    <>
      {!disableTitle && (
        <Typography className={classes.tableTitle}>
          {message({ id: "successfullyImported" })}
        </Typography>
      )}
      <OLTable
        disableColumnManager
        tableName={CAMPAING_IMPORT_SUCCESS_ID}
        onSort={() => {}}
        columns={headItems}
        rows={createItems(campaigns)}
        sort={{ order: "asc", property: "", rowsPerPage: 10, page: 1 }}
        disableActions
      />
    </>
  );
};
